// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__T1VAo","link":"HeaderSimple_link__OonGW"};